<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter justify-center"
  >
    <div class="vx-col w-full md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <checkout></checkout>
    </div>
  </div>
</template>

<script>
import checkout from '@/views/checkout/ECommerceCheckout';

export default {
  components: { checkout },
  data() {
    return {
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
};
</script>
